import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OffersHttpEndpointKind } from '../../../shared/views/offers/enums/offers-http-endpoint-kind.enum';
import { OffersHttpService } from '../../../shared/views/offers/services/offers-http.service';
import { OffersService } from '../../../shared/views/offers/services/offers.service';
import { OfferDashboardTab } from '../../../shared/views/offers/interfaces/offer-dashboard-tab.enum';
import { OfferStatusFilter } from '../../../shared/views/offers/interfaces/offer-status-filter.enum';
import { IOffer } from '../../../shared/views/offers/interfaces/offer.interface';
import {
  ISponsorOfferDetailsApiResponse,
} from '../interfaces/sponsor-offers-api-aliases.interface';

@Injectable({
  providedIn: 'root',
})
export class SponsorOffersService {
  public static readonly openDrawerFromUrlOfferIdQueryParam = 'offerId';

  private readonly offersHttp = inject(OffersHttpService);
  private readonly offersService = inject(OffersService);

  public loadOffers(tab: OfferDashboardTab, statusFilter: OfferStatusFilter): void {
    this.offersService.loadOffersList(OffersHttpEndpointKind.Sponsor, tab, statusFilter);
  }

  public getSponsorOfferDetails(offerId: string): Observable<ISponsorOfferDetailsApiResponse> {
    return this.offersHttp.getOfferDetails(
      OffersHttpEndpointKind.Sponsor,
      offerId,
    ) as Observable<ISponsorOfferDetailsApiResponse>;
  }

  public openOfferDrawer(offer: IOffer): void {
    this.offersService.openOfferDrawerWithDetails(offer, () =>
      this.getSponsorOfferDetails(offer.id),
    );
  }
}
